import ModalVerificationVerify from './ModalVerificationVerify';

export default ModalVerificationVerify;
